module.exports = __webpack_public_path__ + "img/05.b3d5d7bf.jpg";